import React, { memo, useCallback, useEffect, useLayoutEffect, useState } from "react";
import { useSelector } from "react-redux";

import LayoutItemViewComponent from "../ListLayoutItemComponent/index";
import folderIcon from '../../../assets/images/folder.png';
import arrowDown from '../../../assets/images/arrow-down.png';
import arrowRight from '../../../assets/images/arrow-right.png';
import { ApplicationState } from "../../../store";
import { LayoutState } from "../../../store/layouts/types";
import '../ListLayoutComponent/style.scss';
import { chooseService } from "../../../utils";
import { isBoolean } from "util";

// export interface LayoutsItemInterface {
//     children: [],
//     views?: [],
//     name: string,
//     id: string
// };

// export interface LayoutsItemInterface {};

export interface LayoutItemInterface {
  layouts: [],
  content?: string,
  views?: [],
  searchValue: string,
  id: string,
  idx?: number // text-indent multiplier
}

const checkIfEmpty = (obj: any, searchValue: string) => {
  const result: any = [];
  const getProp: any = (o: any) => {
    if (o.length > 0) {
      let tempResult = {};
      for (let prop of o) {
        if (prop['children'].length > 0) {
          const isEmpty = getProp(prop['children']);
          for (let i = 0; i !== Object.keys(isEmpty).length; i++) {
            if (isEmpty[Object.keys(isEmpty)[i]]) {
              createViewsComponents(prop['views'], i, '', searchValue).length > 0
                ? result.push({[prop.id]: false})
                : result.push({[prop.id]: true});

              tempResult = {
                ...tempResult,
                [prop.id]: createViewsComponents(prop['views'], i, '', searchValue).length <= 0
              };
            } else {
              result.push({[prop.id]: false});
              tempResult = {
                ...tempResult,
                [prop.id]: false
              };
            }
          }
        } else {
          createViewsComponents(prop['views'], 0, '', searchValue).length > 0
            ? result.push({[prop.id]: false})
            : result.push({[prop.id]: true});

          tempResult = {
            ...tempResult,
            [prop.id]: createViewsComponents(prop['views'], 0, '', searchValue).length <= 0
          };
        }
      }
      return tempResult;
    }
  }
  getProp(obj);
  return result;
}

const checkIfEmptyCayuga = (obj: any, searchValue: string) => {
  const getProp: any = (o: any) => {
    if (Array.isArray(o)) {
      for (let el of o) {
        if (getProp(el)) {
          return true;
        }
      }
      return false;
    } else {
      if (o['a:EntityType'] === 'PathBranch'
        || o['a:EntityType'] === 'PathFolder'
        || o['a:EntityType'] === 'PathRoot') {
        return getProp(o['a:SubEntities']['a:GeneralEntityInfo']);
      } else if (o['a:EntityType'] === 'Layer' || o['a:EntityType'] === 'Map' || o['a:EntityType'] === 'WebPage') {
        return o['a:EntityName'].toLowerCase().includes(searchValue.toLowerCase());
      } else {
        return false;
      }
    }
  }

  return getProp(obj);
}

const createViewsComponents = (views: any[], idx: number, id: string, searchValue: string) => {
  const style = {textIndent: idx * 10 + 'px'};

  return chooseService(
    () => views
      .filter(({name}: any) => name.toLowerCase().includes(searchValue.toLowerCase()))
      .map((view: any) => {
        return <LayoutItemViewComponent
          key={Math.random() * 1000}
          style={style}
          view={view}
          groupId={id}
        />
      }),
    () => views
      .filter((view: any) => view['a:EntityName'].toLowerCase().includes(searchValue.toLowerCase()))
      .sort((a, b) => {
        const nameA: string = a['a:EntityName'].toLowerCase();
        const nameB: string = b['a:EntityName'].toLowerCase();
        return nameA < nameB ? -1 : 1;
      })
      .map((view: any) => {
        return <LayoutItemViewComponent
          key={Math.random() * 1000}
          style={style}
          view={view}
          groupId={id}
        />
      }),
  );
};

const createListComponents = (Component: React.FC<LayoutItemInterface>, layouts: Array<any>, searchValue: string, idx?: number) => {
  return layouts && layouts.map((layout: any) => {
    return chooseService(
      () => <Component
        layouts={layout.children}
        content={layout.name}
        views={layout.views}
        key={layout.id}
        searchValue={searchValue}
        id={layout.id}
        idx={idx}
      />,
      () => {
        if (layout['a:EntityType'] === 'PathBranch'
          || layout['a:EntityType'] === 'PathFolder'
          || layout['a:EntityType'] === 'PathRoot'
          || layout['a:EntityType'] === 'Layer'
          || layout['a:EntityType'] === 'Map'
          || layout['a:EntityType'] === 'WebPage') {
          let layoutChildren: any = Array.isArray(layout['a:SubEntities']['a:GeneralEntityInfo']) ? layout['a:SubEntities']['a:GeneralEntityInfo'] : new Array(layout['a:SubEntities']['a:GeneralEntityInfo'])
          if (layout['a:EntityType'] === 'Layer' || layout['a:EntityType'] === 'Map' || layout['a:EntityType'] === 'WebPage') {
            layoutChildren = [];
          }
          let views = [];
          if (layout['a:EntityType'] === 'PathBranch'
            || layout['a:EntityType'] === 'PathFolder'
            || layout['a:EntityType'] === 'PathRoot') {
            views = layoutChildren.filter((l: any) => l['a:EntityType'] === 'Layer' || l['a:EntityType'] === 'Map' || l['a:EntityType'] === 'WebPage');
          }
          return <Component
            layouts={layoutChildren}
            content={layout['a:EntityName']}
            views={views}
            key={layout['a:EntityID']}
            searchValue={searchValue}
            id={layout['a:EntityID']}
            idx={idx}
          />
        }
      }
    )
  })
};


const LayoutLIComponent = memo(({layouts, content, views, searchValue, id, idx}: LayoutItemInterface) => {
  const {expandedLayoutList} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
  const [isEmptyList, setIsEmptyList] = useState([]);
  if (idx === undefined || !views) return null;

  const style = {textIndent: idx * 10 + 'px', height: 'auto'};

  const list = createListComponents(LayoutLIComponent, layouts, searchValue, ++idx);
  const viewsElems = createViewsComponents(views, idx, id, searchValue);

  useLayoutEffect(() => {
    const filteredLayout = chooseService(
      () => checkIfEmpty(layouts, searchValue),
      () => checkIfEmptyCayuga(layouts, searchValue)
    );
    setIsEmptyList(filteredLayout);
  }, [searchValue]);


  const [isHide, setIsHide] = useState(false);
  let arrow = isHide ? arrowRight : arrowDown;

  const triggerHide = useCallback(() => setIsHide(!isHide), [isHide]);

  useEffect(() => {
    if (expandedLayoutList === null) return;
    if (expandedLayoutList && isHide) triggerHide();
    if (!expandedLayoutList && !isHide) triggerHide();
  }, [expandedLayoutList]);

  const Title = () => {
    return ((content && isBoolean(isEmptyList) ? isEmptyList : (isEmptyList.length > 0
        ? isEmptyList.some(li => {
        return li[Object.keys(li)[0]] === false;
      }) || viewsElems.length > 0
        : viewsElems.length > 0))
        ? <div className='list-item-row'>
          <img src={arrow}
               alt="arrow"
               className='m-r-5 pointer'
               onClick={triggerHide}
          />
          <img src={folderIcon}
               alt="folder"
               className='m-r-5'
          />
          {content}
        </div>
        : null
    )
  };

  return <li style={style}>
    <Title/>
    {
      <div className={isHide ? 'hide' : ''}>
        {
          list && <ul>
            {list}
          </ul>
        }
        {
          viewsElems && <ul>
            {viewsElems}
          </ul>
        }
      </div>
    }
  </li>
});

export {
  createListComponents,
  LayoutLIComponent
}